/**
 * ## Offline state manager
 * @module client/offline
 */

"use strict";

const config = require("../../config/client");

/**
 * Sync with messages from server
 * @param {Object} _socket - current client socket
 * @param {Object} db - current client db
 * @returns {Promise} - resolves into true
 */
// will eventually check each domain, activity for now
const initialize = (_socket, db) =>
  new Promise((resolve) => {
    config.domains.forEach((domain) => {
      const offlineDocs = db.collections[domain].where((obj) => {
        if (
          obj.hasOwnProperty("_kd") &&
          obj._kd.hasOwnProperty("offline") &&
          obj._kd.offline === true
        ) {
          return true;
        }
      });
      offlineDocs.map((document) => {
        const doc = document;
        doc._kd.offline = false;
        return _socket.emit(`${doc.domain}.update`, doc);
      });
    });
    resolve(true);
  });

module.exports = {
  initialize,
};



/** WEBPACK FOOTER **
 ** ./src/client/offline/index.js
 **/